import { useEffect } from 'react';

// Disabilita lo scroll del body quando si apre il drawer
export const useBodyScroll = (opened: boolean) => {
  useEffect(() => {
    const body = document.querySelector('body');
    body?.classList.toggle('drawer-opened', opened);
    return () => {
      body?.classList.remove('drawer-opened');
    };
  }, [opened]);
};
